import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio, Select, MenuItem } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";
import { asyncRequest } from "src/services/network";
import UserPicker from "src/components/common/UserPicker";
import { useEffect } from "react";
import { TIEJUN_LEVELS } from "src/config/constants";
import TiejunPicker from "src/components/common/TiejunPicker";

const levels = Object.values(TIEJUN_LEVELS);

const TiejunEditDialog = ({ action, tiejun, open, onClose, onUpdate }) => {
  const [form, setForm] = useState({
    mobile: tiejun.mobile || "",
    realname: tiejun.realname || "",
    idNo: tiejun.idNo || "",
  });

  const [user, setUser] = useState({});

  // useEffect(() => {
  //   if (action !== "edit") return;

  //   setForm({
  //     uid: staff.uid,
  //   });
  //   setUser(staff);
  // }, [staff]);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (!form.realname || !form.mobile) return alert("请填写完整信息");

    const { msg } = await asyncRequest({
      path: "/user/tiejun/edit",
      data: {
        ...form,
        id: tiejun.id,
      },
    });

    alert(msg, "success");
    onUpdate();
  }

  return (
    <FormDialog title="编辑铁军" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="真实姓名" required>
        <TextField fullWidth value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
      </FormItem>

      <FormItem title="手机号" required>
        <TextField fullWidth value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
      </FormItem>

      <FormItem title="身份证号" required>
        <TextField fullWidth value={form.idNo} size="small" onChange={(e) => handleIptChange("idNo", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default TiejunEditDialog;
